var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-tables',{attrs:{"sort-key":"1","desc":"","endpoint":("v1/user_logs?id_user=" + _vm.id),"fields":_vm.fields},scopedSlots:_vm._u([{key:"1",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("fulldate")(item[1]))+" ")]}}])}),_c('small',[_vm._v("Aktivitas yang ditampilkan adalah 100 aktivitas terakhir")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }